export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_08_blank.48f4469d.png";